"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgFinanceManualOperationCtl = /** @class */ (function (_super) {
    __extends(DlgFinanceManualOperationCtl, _super);
    function DlgFinanceManualOperationCtl() {
        return _super.call(this, true) || this;
    }
    DlgFinanceManualOperationCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            //  description : "",
            amount: 100,
            currency_title: "",
            title: "",
            visible: false,
            show_description: true,
            show_tag: false
        };
    };
    DlgFinanceManualOperationCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgFinanceManualOperationCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgFinanceManualOperationCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgFinanceManualOperationCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgFinanceManualOperationCtl.prototype.SetOnYesClick = function (callback) {
        this.DATA.onYes = callback;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgFinanceManualOperationCtl.prototype, "onYesClick", {
        get: function () {
            return this.DATA.onYes;
        },
        enumerable: true,
        configurable: true
    });
    DlgFinanceManualOperationCtl.prototype.SetTitle = function (title) {
        this.DATA.title = title;
        this.Update();
        return this;
    };
    DlgFinanceManualOperationCtl.prototype.SetDescriptionVisibility = function (visible) {
        this.DATA.show_description = visible;
        this.Update();
        return this;
    };
    DlgFinanceManualOperationCtl.prototype.SetTagVisibility = function (visible) {
        this.DATA.show_tag = visible;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgFinanceManualOperationCtl.prototype, "Title", {
        get: function () {
            return this.DATA.title;
        },
        enumerable: true,
        configurable: true
    });
    DlgFinanceManualOperationCtl.prototype.SetCurrencyTitle = function (title) {
        this.DATA.currency_title = title;
        this.Update();
        return this;
    };
    Object.defineProperty(DlgFinanceManualOperationCtl.prototype, "CurrencyTitle", {
        get: function () {
            return this.DATA.currency_title;
        },
        enumerable: true,
        configurable: true
    });
    //  public SetDescription(description : string) : DlgFinanceManualOperationCtl {
    //      this.DATA.description = description;
    //      this.Update();
    //      return this;
    //  }
    //  public get Description() : string {
    //      return this.DATA.description;
    //  }
    DlgFinanceManualOperationCtl.prototype.SetAmount = function (amount) {
        this.DATA.amount = amount;
        this.Update();
        return this;
    };
    return DlgFinanceManualOperationCtl;
}(BaseController_1.BaseController));
exports.DlgFinanceManualOperationCtl = DlgFinanceManualOperationCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgFinanceManualOperationCtl.ts
// module id = 895
// module chunks = 0